export const stringifySelectOption = (option: any) => {
	if (!option) {
		return "";
	}

	if (typeof option === "object") {
		const keywords: string[] = ["value", "title", "name", "label", "option", "id"];

		for (const keyword of keywords) {
			if (option.hasOwnProperty(keyword) && typeof option[keyword] === "string") {
				return option[keyword];
			}
		}

		const keys = Object.keys(option);
		for (const key of keys) {
			if (typeof option[key] === "string") {
				return option[key];
			}
		}
	} else if (typeof option === "string") {
		return option;
	} else {
		return `${option}`;
	}
};
